import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Date",
  "use": "Date-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Date\">\r\n<g id=\"Date_icon / Date\">\r\n<path id=\"Date_Vector\" d=\"M9 11.5H7V13.5H9V11.5ZM13 11.5H11V13.5H13V11.5ZM17 11.5H15V13.5H17V11.5ZM19 4.5H18V2.5H16V4.5H8V2.5H6V4.5H5C3.89 4.5 3.01 5.4 3.01 6.5L3 20.5C3 21.6 3.89 22.5 5 22.5H19C20.1 22.5 21 21.6 21 20.5V6.5C21 5.4 20.1 4.5 19 4.5ZM19 20.5H5V9.5H19V20.5Z\" fill=\"#3A3A3A\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol